export default __webpack_public_path__ + "static/media/user_progress_detail.2d49554f.png";